import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const en = {
  // English (en)
  products: "Products",
  description: "Description",
  itemsAvailable: "items available",
  youSave: "You save",
  all: "All",
  close: "Close",

  Morning: "Morning Schedule",
  Afternoon: "Afternoon Schedule",
  Evening: "Evening Schedule",

  WorkingHours: "Working Hours",
  closed: "Closed",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  Sunday: "Sunday",

  LeaveReview: "Leave Review",

  SalonsFor: "salons for",

  ShowingMoreThan: "Showing more than",

  SearchByNameOrPhoneNumber: "Search by name or phone number...",

  Below: "Below",

  AllRatings: "All Ratings",

  GettingLocation: "Getting Location...",

  CloseToMe: "Close to Me",

  BookAppointment: "Book Appointment",

  DownloadBokahitBusinessForBusinessOwners:
    "Download Bokahit Business For Business Owners",

  FindProfessionalBarbersAndSalons:
    "Find professional barbers and salons near you. Schedule instantly, no hassle.",
  ListYourBusiness: "List Your Business",

  BookYourAppointmentInSeconds: "Book Your Appointment in Seconds",

  Featured: "Featured",
  MainGalleryImage: "Main gallery image",
  Loadinggallery: "Loading gallery...",
  NoImagesYet: "No Images Yet",
  Checkbacksoonforourlatestwork: "Check back soon for our latest work",
  Galleryimage: "Gallery image",
  View: "View",
  Close: "Close",
  Previousimage: "Previous image",
  Nextimage: "Next image",
  // Days of the week (short)
  Sun: "Sun",
  Mon: "Mon",
  Tue: "Tue",
  Wed: "Wed",
  Thu: "Thu",
  Fri: "Fri",
  Sat: "Sat",
  // Days of the week (full)
  Sunday: "Sunday",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  // Months (short)
  Jan: "Jan",
  Feb: "Feb",
  Mar: "Mar",
  Apr: "Apr",
  May: "May",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Aug",
  Sep: "Sep",
  Oct: "Oct",
  Nov: "Nov",
  Dec: "Dec",
  // Months (full)
  January: "January",
  February: "February",
  March: "March",
  April: "April",
  June: "June",
  July: "July",
  August: "August",
  September: "September",
  October: "October",
  November: "November",
  December: "December",
  // Booking Flow
  SelectABarber: "Select a barber",
  ChoosePreferredBarber: "Choose your preferred barber to continue",
  NextSelectServices: "Next: Select Services",
  ChooseYourBarber: "Choose Your Barber",
  SelectBarberForAppointment: "Select a barber for your appointment",
  Barber: "Barber",
  ProfessionalBarber: "Professional Barber",
  Change: "Change",
  YourBarber: "Your Barber",
  SelectYourServices: "Select Your Services",
  ChooseOneOrMoreServices: "Choose one or more services",
  Minutes: "Minutes",
  TotalDuration: "Total Duration",
  TotalPrice: "Total Price",
  SelectAtLeastOneService: "Select at least one service",
  ChooseFromServices: "Choose from the available services above",
  NextSelectDateTime: "Next: Select Date & Time",
  SelectedServices: "Selected Services",
  Edit: "Edit",
  SelectDate: "Select Date",
  Today: "Today",
  AvailableTimes: "Available Times",
  TotalDurationNeeded: "Total duration needed:",
  ShowingConsecutiveSlots:
    "Showing only time slots with enough consecutive availability",
  NoAvailableAppointments: "No Available Appointments",
  BackToServices: "Back to Services",
  Services: "Services",
  Book: "Book",

  // Contact
  NeedHelpOrHaveQuestions: "Need Help or Have Questions?",
  ContactOurSupportTeam: "Contact our support team - we're here to assist you",
  ContactOnWhatsApp: "Contact on WhatsApp",
  WhatsApp: "WhatsApp",
  ChatWithUs: "Chat with us",
  Phone: "Phone",
  CallUs: "Call us directly",
  Contact: "Contact",
  GetInTouch: "Get In Touch",
  ContactDescription: "Have questions? We're here to help!",
  SMS: "SMS",
  TextUs: "Send us a text",
  ContactAvailability: "Available 24/7 to assist you",

  // Navigation
  Features: "Features",
  MobileApp: "Mobile App",
  Benefits: "Benefits",
  GetStarted: "Get Started",

  // Hero Section
  TrustedByProfessionals: "🚀 Trusted by 10,000+ professionals",
  AppointmentManagement: "Appointment Management,",
  Simplified: "Simplified",
  HeroDescription:
    "Transform your scheduling chaos into seamless operations. NoholTorem brings together powerful booking tools, client management, and analytics in one beautiful platform.",
  StartFreeTrial: "Start Free Trial",
  WatchDemo: "Watch Demo",

  // Stats
  ActiveUsers: "Active Users",
  AppointmentsBooked: "Appointments Booked",
  Uptime: "Uptime",
  UserRating: "User Rating",

  // Features Section
  EverythingYouNeedTo: "Everything You Need to",
  Succeed: "Succeed",
  BuiltForProfessionals:
    "Built for professionals who demand excellence in every detail",

  SmartScheduling: "Smart Scheduling",
  SmartSchedulingDesc:
    "Intelligent appointment management that adapts to your workflow and eliminates double bookings",
  SmartSchedulingStat: "99.8% accuracy",

  ClientManagement: "Client Management",
  ClientManagementDesc:
    "Comprehensive client profiles with history, preferences, and automated communication",
  ClientManagementStat: "50% time saved",

  AnalyticsInsights: "Analytics & Insights",
  AnalyticsInsightsDesc:
    "Real-time statistics and predictive analytics to optimize your business performance",
  AnalyticsInsightsStat: "3x growth",

  // Mobile App Section
  AvailableOnMobile: "Available on Mobile",
  ManageEverything: "Manage Everything",
  OnTheGo: "On the Go",
  MobileAppDescription:
    "Download the NoholTorem mobile app and take control of your appointments from anywhere",

  YourBusinessInYourPocket: "Your Business in Your Pocket",
  MobileAppFullDescription:
    "The NoholTorem mobile app gives you complete control over your appointments, clients, and business analytics—right from your smartphone.",

  RealTimeSync: "Real-time Sync",
  RealTimeSyncDesc: "Instant updates across all your devices",

  PushNotifications: "Push Notifications",
  PushNotificationsDesc: "Never miss an appointment or message",

  WorksOffline: "Works Offline",
  WorksOfflineDesc: "Access your data even without internet",

  DownloadNow: "Download Now",
  GetItOnGooglePlay: "GET IT ON",
  GooglePlay: "Google Play",
  DownloadOnTheAppStore: "Download on the",
  AppStore: "App Store",

  FreeToDownload: "✨ Free to download • Available worldwide • Regular updates",

  SeeItInAction: "See It in Action",

  // Benefits Section
  WhyProfessionalsChoose: "Why Professionals Choose",
  NoholTorem: "NoholTorem",
  BenefitsDescription:
    "Join thousands of businesses who've transformed their operations with intelligent appointment management.",

  SaveHoursDaily: "Save Hours Daily",
  SaveHoursDesc: "Automate repetitive tasks and focus on what matters",

  NeverMissAppointment: "Never Miss an Appointment",
  NeverMissDesc: "Automated reminders and smart notifications",

  InstantSetup: "Instant Setup",
  InstantSetupDesc: "Get started in under 5 minutes",

  BoostRevenue: "Boost Revenue",
  BoostRevenueDesc: "Reduce no-shows by 67% with smart reminders",

  TodaysAppointments: "Today's Appointments",
  ClientSatisfaction: "Client Satisfaction",
  ThisMonthRevenue: "This Month's Revenue",
  PercentageFromLastMonth: "+23% from last month",
  ActiveClients: "Active Clients",
  ShowRate: "Show Rate",

  // CTA Section
  ReadyToTransform: "Ready to Transform Your Business?",
  CTADescription:
    "Join 10,000+ professionals who trust NoholTorem for their scheduling needs",
  DownloadApp: "Download App",
  FreeTrial: "No credit card required • 45-day free trial • Cancel anytime",

  // Footer
  Privacy: "Privacy",
  Terms: "Terms",
  CopyrightMainPage: "© 2024 NoholTorem. All rights reserved.",
  CustomerReviews: "Customer Reviews",
  SeeWhatOurCustomersSay: "See what our customers say about us",
  OutOf: "out of",
  Reviews: "reviews",
  NoComment: "No comment provided",
  TheMainPage: "Main Page",
  Gallery: "Gallery",
  myappointments: "My Appointments",
  ContactInfo: "Contact Info",
  Chooselanguage: "Choose language",
  Home: "Home",
  MyAppointments: "My Appointments",
  Loading: "Loading...",
  BookYourAppointment: "Book Your Appointment",
  ChoosePreferredDateTime: "Choose your preferred date and time",
  OnlineBookingComingSoon: "Online Booking Coming Soon",
  BarberStopDescription:
    "BarberStop allows scheduling appointments through the app! Currently, this feature is being set up.",
  InTheMeantime: "In the meantime, book your appointment via:",
  PhoneCall: "Phone Call",
  Tip: "Tip:",
  MentionBarberStop: 'Mention "BarberStop" when you reach out!',
  ModernBookingSolutions: "Modern Booking Solutions",
  Copyright: "© 2026 NoholTorem. All rights reserved.",

  // Business Owner
  ForBusinessOwners: "For Business Owners",
  WantYourOwnBusinessApp: "Want Your Own Business?",
  DownloadNoholToremForBusinessOwners:
    "Download NoholTorem and start managing your barber shop today!",
  Business: "Business",
  WhatsIncluded: "What's Included:",
  ManageAppointments: "Manage appointments online",
  TrackCustomers: "Track your customers",
  IncreaseRevenue: "Increase your revenue",
  BusinessAnalytics: "Business analytics & reports",
  JoinThousandsOfBarbers:
    "Join thousands of barbers managing their business with NoholTorem",
  DownloadOnThe: "Download on the",
  GetItOn: "GET IT ON",

  // User Appointments
  PleaseLoginToView: "Please log in to view your appointments",
  SignInToAccess:
    "Sign in to access your appointment history and manage bookings",
  LoadingYourAppointments: "Loading your appointments...",
  ManageYourBookings: "Manage your upcoming bookings",
  User: "User",
  Logout: "Logout",
  NoAppointmentsYet: "No appointments yet",
  BookYourFirst: "Book your first appointment to get started with our services",
  TodaysAppointment: "Today's Appointment",
  Past: "Past",
  Min: "min",
  Total: "Total",
  CancelAppointment: "Cancel Appointment",
  CancelAppointmentQuestion: "Cancel Appointment?",
  CancelConfirmation:
    "Are you sure you want to cancel this appointment? This action cannot be undone.",
  KeepIt: "Keep It",
  YesCancel: "Yes, Cancel",

  // Login
  Login: "Login",
  BarberStep: "Barber",
  ServicesStep: "Services",
  Welcome: "Welcome! 👋",
  EnterPhoneToGetStarted: "Enter your phone number to get started",
  PhoneNumber: "Phone Number",
  FullNumber: "Full Number:",
  Sending: "Sending...",
  SendVerificationCode: "Send Verification Code",
  VerifyYourNumber: "Verify Your Number 🔐",
  WeSentCodeTo: "We sent a code to",
  VerificationCode: "Verification Code",
  EnterSixDigitCode: "Enter 6-digit code",
  Verifying: "Verifying...",
  VerifyCode: "Verify Code",
  Verify: "Verify",
  ChangePhoneNumber: "← Change Phone Number",
  AlmostThere: "Almost There! ✨",
  EnterNameToComplete: "Please enter your name to complete registration",
  YourName: "Your Name",
  Name: "Name",
  EnterFullName: "Enter your full name",
  Completing: "Completing...",
  CompleteRegistration: "Complete Registration",
  PleaseEnterValidPhone: "Please enter a valid phone number",
  OTPSentTo: "OTP sent to",
  ErrorMessage: "Error:",
  PhoneVerifiedSuccessfully: "Phone verified successfully!",
  PleaseEnterValidOTP: "Please enter a valid 6-digit OTP",
  InvalidOTP: "Invalid OTP. Please try again.",
  PleaseEnterYourName: "Please enter your name",
  LoginSuccessful: "Login successful!",
  FailedToSaveUser: "Failed to save user:",

  // Booking Confirmation
  ConfirmYourBooking: "Confirm Your Booking",
  ReviewAppointmentDetails: "Review your appointment details below",
  YourInformation: "YOUR INFORMATION",
  Guest: "Guest",
  NotAvailable: "N/A",
  BarberDetails: "BARBER DETAILS",
  AppointmentDetails: "APPOINTMENT DETAILS",
  Date: "Date",
  Time: "Time",
  Duration: "Duration",
  SelectedServicesUpper: "SELECTED SERVICES",
  Cancel: "Cancel",
  BookingInProgress: "Booking...",
  ConfirmBooking: "Confirm Booking",
  ConfirmationMessage: "Confirmation Message",
  WhatsAppConfirmation: "You'll receive a WhatsApp confirmation shortly",
  NoConsecutiveSlotsFound:
    "No consecutive slots found with {duration} minutes available. Try selecting another date or fewer services.",
  PleaseSelectAnotherDate: "Please select another date",

  // Main Page Categories
  WhatAreYouLookingFor: "What are you looking for?",
  BrowseCategories: "Browse Categories",
  Haircut: "Haircut",
  Nails: "Nails",
  Lashes: "Lashes",

  // Main Page Login Modal
  SignInToContinue: "Sign in to continue",

  // Review Dialog
  EditName: "Edit Name",
  Save: "Save",
  Rating: "Rating",
  Comment: "Comment",
  Optional: "Optional",
  ShareYourThoughts: "Share your thoughts about the service...",
  ShareYourExperience: "Share your experience with this service",
  Submit: "Submit Review",
  Poor: "Poor",
  Fair: "Fair",
  Good: "Good",
  VeryGood: "Very Good",
  Excellent: "Excellent",
  ReviewSubmitted: "Review Submitted",
  ErrorSubmittingReview: "Error submitting review. Please try again.",
  PleaseSelectRating: "Please select a rating",
  ErrorUpdatingName: "Error updating name",
  ResendCode: "Resend Code",

  // Cancellation Policy
  CancellationPolicy: "Cancellation Policy",
  CancellationPolicyNote: "Appointments cannot be cancelled within 4 hours of the scheduled time. Please plan accordingly.",
};

const ar = {
  // Arabic (ar)
  products: "المنتجات",
  description: "الوصف",
  itemsAvailable: "عناصر متاحة",
  youSave: "توفر",
  all: "الكل",
  close: "إغلاق",
  Morning: "جدول الصباح",
  Afternoon: "جدول الظهيرة",
  Evening: "جدول المساء",
  WorkingHours: "ساعات العمل",
  closed: "مغلق",
  Monday: "الاثنين",
  Tuesday: "الثلاثاء",
  Wednesday: "الأربعاء",
  Thursday: "الخميس",
  Friday: "الجمعة",
  Saturday: "السبت",
  Sunday: "الأحد",

  LeaveReview: "اترك تقييمًا",

  SalonsFor: "صالونات لـ",

  ShowingMoreThan: "يعرض أكثر من",

  SearchByNameOrPhoneNumber: "ابحث بالاسم أو رقم الهاتف...",

  Below: "أقل من",

  AllRatings: "جميع التقييمات",

  GettingLocation: "جاري تحديد الموقع...",

  CloseToMe: "بالقرب مني",

  BookAppointment: "احجز موعد",

  DownloadBokahitBusinessForBusinessOwners:
    "حمّل Bokahit Business لأصحاب الأعمال",

  ListYourBusiness: "أضف نشاطك التجاري",

  FindProfessionalBarbersAndSalons:
    "اعثر على حلاقين محترفين وصالونات بالقرب منك. احجز فوراً بدون أي متاعب.",

  BookYourAppointmentInSeconds: "احجز موعدك في ثوانٍ",

  Featured: "مميز",
  MainGalleryImage: "الصورة الرئيسية للمعرض",
  Loadinggallery: "جاري تحميل المعرض...",
  NoImagesYet: "لا توجد صور بعد",
  Checkbacksoonforourlatestwork: "تحقق قريباً من أحدث أعمالنا",
  Galleryimage: "صورة المعرض",
  View: "عرض",
  Close: "إغلاق",
  Previousimage: "الصورة السابقة",
  Nextimage: "الصورة التالية",
  // Days of the week (short)
  Sun: "الأحد",
  Mon: "الاثنين",
  Tue: "الثلاثاء",
  Wed: "الأربعاء",
  Thu: "الخميس",
  Fri: "الجمعة",
  Sat: "السبت",
  // Days of the week (full)
  Sunday: "الأحد",
  Monday: "الاثنين",
  Tuesday: "الثلاثاء",
  Wednesday: "الأربعاء",
  Thursday: "الخميس",
  Friday: "الجمعة",
  Saturday: "السبت",
  // Months (short)
  Jan: "يناير",
  Feb: "فبراير",
  Mar: "مارس",
  Apr: "أبريل",
  May: "مايو",
  Jun: "يونيو",
  Jul: "يوليو",
  Aug: "أغسطس",
  Sep: "سبتمبر",
  Oct: "أكتوبر",
  Nov: "نوفمبر",
  Dec: "ديسمبر",
  // Months (full)
  January: "يناير",
  February: "فبراير",
  March: "مارس",
  April: "أبريل",
  June: "يونيو",
  July: "يوليو",
  August: "أغسطس",
  September: "سبتمبر",
  October: "أكتوبر",
  November: "نوفمبر",
  December: "ديسمبر",
  // Booking Flow
  SelectABarber: "اختر حلاقًا",
  ChoosePreferredBarber: "اختر الحلاق المفضل لديك للمتابعة",
  NextSelectServices: "التالي: اختر الخدمات",
  ChooseYourBarber: "اختر حلاقك",
  SelectBarberForAppointment: "اختر حلاقًا لموعدك",
  Barber: "حلاق",
  ProfessionalBarber: "حلاق محترف",
  Change: "تغيير",
  YourBarber: "حلاقك",
  SelectYourServices: "اختر خدماتك",
  ChooseOneOrMoreServices: "اختر خدمة واحدة أو أكثر",
  Minutes: "دقائق",
  TotalDuration: "المدة الإجمالية",
  TotalPrice: "السعر الإجمالي",
  SelectAtLeastOneService: "اختر خدمة واحدة على الأقل",
  ChooseFromServices: "اختر من الخدمات المتاحة أعلاه",
  NextSelectDateTime: "التالي: اختر التاريخ والوقت",
  SelectedServices: "الخدمات المختارة",
  Edit: "تعديل",
  SelectDate: "اختر التاريخ",
  Today: "اليوم",
  AvailableTimes: "الأوقات المتاحة",
  TotalDurationNeeded: "المدة الإجمالية المطلوبة:",
  ShowingConsecutiveSlots: "عرض فقط الأوقات المتاحة المتتالية الكافية",
  NoAvailableAppointments: "لا توجد مواعيد متاحة",
  BackToServices: "العودة إلى الخدمات",
  Services: "الخدمات",
  Book: "حجز",

  // Contact
  NeedHelpOrHaveQuestions: "هل تحتاج مساعدة أو لديك أسئلة؟",
  ContactOurSupportTeam: "اتصل بفريق الدعم لدينا - نحن هنا لمساعدتك",
  ContactOnWhatsApp: "تواصل عبر واتساب",
  WhatsApp: "واتساب",
  ChatWithUs: "تحدث معنا",
  Phone: "الهاتف",
  CallUs: "اتصل بنا مباشرة",
  Contact: "اتصل بنا",
  GetInTouch: "تواصل معنا",
  ContactDescription: "لديك أسئلة؟ نحن هنا للمساعدة!",
  SMS: "رسالة نصية",
  TextUs: "أرسل لنا رسالة",
  ContactAvailability: "متاحون على مدار الساعة لمساعدتك",

  // Navigation
  Features: "المميزات",
  MobileApp: "تطبيق الموبايل",
  Benefits: "الفوائد",
  GetStarted: "ابدأ الآن",

  // Hero Section
  TrustedByProfessionals: "🚀 موثوق به من قبل أكثر من 10,000 محترف",
  AppointmentManagement: "إدارة المواعيد،",
  Simplified: "مبسطة",
  HeroDescription:
    "حوّل فوضى جدولة المواعيد إلى عمليات سلسة. يجمع نهول توريم بين أدوات الحجز القوية وإدارة العملاء والتحليلات في منصة واحدة جميلة.",
  StartFreeTrial: "ابدأ تجربة مجانية",
  WatchDemo: "شاهد العرض التوضيحي",

  // Stats
  ActiveUsers: "مستخدم نشط",
  AppointmentsBooked: "موعد محجوز",
  Uptime: "وقت التشغيل",
  UserRating: "تقييم المستخدم",

  // Features Section
  EverythingYouNeedTo: "كل ما تحتاجه",
  Succeed: "للنجاح",
  BuiltForProfessionals: "مصمم للمحترفين الذين يطالبون بالتميز في كل التفاصيل",

  SmartScheduling: "جدولة ذكية",
  SmartSchedulingDesc:
    "إدارة ذكية للمواعيد تتكيف مع سير عملك وتزيل الحجوزات المزدوجة",
  SmartSchedulingStat: "دقة 99.8%",

  ClientManagement: "إدارة العملاء",
  ClientManagementDesc:
    "ملفات تعريف شاملة للعملاء مع السجل والتفضيلات والتواصل الآلي",
  ClientManagementStat: "توفير 50% من الوقت",

  AnalyticsInsights: "التحليلات والرؤى",
  AnalyticsInsightsDesc:
    "إحصائيات في الوقت الفعلي وتحليلات تنبؤية لتحسين أداء عملك",
  AnalyticsInsightsStat: "نمو 3 أضعاف",

  // Mobile App Section
  AvailableOnMobile: "متاح على الموبايل",
  ManageEverything: "إدارة كل شيء",
  OnTheGo: "أثناء التنقل",
  MobileAppDescription:
    "قم بتنزيل تطبيق نهول توريم للهاتف المحمول وتحكم في مواعيدك من أي مكان",

  YourBusinessInYourPocket: "عملك في جيبك",
  MobileAppFullDescription:
    "يمنحك تطبيق نهول توريم للهاتف المحمول تحكمًا كاملاً في مواعيدك وعملائك وتحليلات عملك - مباشرة من هاتفك الذكي.",

  RealTimeSync: "مزامنة فورية",
  RealTimeSyncDesc: "تحديثات فورية عبر جميع أجهزتك",

  PushNotifications: "إشعارات فورية",
  PushNotificationsDesc: "لا تفوت أي موعد أو رسالة",

  WorksOffline: "يعمل بدون إنترنت",
  WorksOfflineDesc: "الوصول إلى بياناتك حتى بدون إنترنت",

  DownloadNow: "حمّل الآن",
  GetItOnGooglePlay: "احصل عليه من",
  GooglePlay: "Google Play",
  DownloadOnTheAppStore: "حمّل على",
  AppStore: "App Store",

  FreeToDownload:
    "✨ مجاني للتحميل • متاح في جميع أنحاء العالم • تحديثات منتظمة",

  SeeItInAction: "شاهده في العمل",

  // Benefits Section
  WhyProfessionalsChoose: "لماذا يختار المحترفون",
  NeholTorem: "نهول توريم",
  BenefitsDescription:
    "انضم إلى آلاف الشركات التي حولت عملياتها بإدارة المواعيد الذكية.",

  SaveHoursDaily: "وفر ساعات يوميًا",
  SaveHoursDesc: "أتمتة المهام المتكررة وركز على ما يهم",

  NeverMissAppointment: "لا تفوت أي موعد",
  NeverMissDesc: "تذكيرات تلقائية وإشعارات ذكية",

  InstantSetup: "إعداد فوري",
  InstantSetupDesc: "ابدأ في أقل من 5 دقائق",

  BoostRevenue: "زد إيراداتك",
  BoostRevenueDesc: "قلل عدم الحضور بنسبة 67% مع التذكيرات الذكية",

  TodaysAppointments: "مواعيد اليوم",
  ClientSatisfaction: "رضا العملاء",
  ThisMonthRevenue: "إيرادات هذا الشهر",
  PercentageFromLastMonth: "+23% من الشهر الماضي",
  ActiveClients: "عملاء نشطون",
  ShowRate: "معدل الحضور",

  // CTA Section
  ReadyToTransform: "هل أنت مستعد لتحويل عملك؟",
  CTADescription:
    "انضم إلى أكثر من 10,000 محترف يثقون في نهول توريم لاحتياجات الجدولة الخاصة بهم",
  DownloadApp: "حمّل التطبيق",
  FreeTrial:
    "لا حاجة لبطاقة ائتمان • تجربة مجانية لمدة 45 يومًا • إلغاء في أي وقت",

  // Footer
  Privacy: "الخصوصية",
  Terms: "الشروط",
  CopyrightMainPage: "© 2024 نهول توريم. جميع الحقوق محفوظة.",
  CustomerReviews: "آراء العملاء",
  SeeWhatOurCustomersSay: "اطلع على آراء عملائنا",
  OutOf: "من أصل",
  Reviews: "مراجعات",
  NoComment: "لا يوجد تعليق",
  myappointments: "مواعيدي",
  TheMainPage: "الصفحة الرئيسية",
  Gallery: "معرض الصور",
  ContactInfo: "معلومات الاتصال",
  Chooselanguage: "اختر اللغة",
  Home: "الرئيسية",
  MyAppointments: "مواعيدي",
  Loading: "جاري التحميل...",
  BookYourAppointment: "احجز موعدك",
  ChoosePreferredDateTime: "اختر التاريخ والوقت المفضل",
  OnlineBookingComingSoon: "الحجز عبر الإنترنت قريباً",
  BarberStopDescription:
    "يتيح BarberStop جدولة المواعيد من خلال التطبيق! حالياً، يتم إعداد هذه الميزة.",
  InTheMeantime: "في هذه الأثناء، احجز موعدك عبر:",
  PhoneCall: "مكالمة هاتفية",
  Tip: "نصيحة:",
  MentionBarberStop: 'اذكر "BarberStop" عند التواصل!',
  ModernBookingSolutions: "حلول الحجز الحديثة",
  Copyright: "© 2026 Bokahit. جميع الحقوق محفوظة.",

  // Business Owner
  ForBusinessOwners: "لأصحاب الأعمال",
  WantYourOwnBusinessApp: "تريد عملك الخاص؟",
  DownloadNeholToremForBusinessOwners:
    "قم بتنزيل نهول توريم وابدأ في إدارة صالون الحلاقة الخاص بك اليوم!",
  Business: "أعمال",
  WhatsIncluded: "ما هو مشمول:",
  ManageAppointments: "إدارة المواعيد عبر الإنترنت",
  TrackCustomers: "تتبع عملائك",
  IncreaseRevenue: "زيادة إيراداتك",
  BusinessAnalytics: "تحليلات وتقارير الأعمال",
  JoinThousandsOfBarbers:
    "انضم إلى آلاف الحلاقين الذين يديرون أعمالهم باستخدام نهول توريم",
  DownloadOnThe: "التنزيل على",
  GetItOn: "احصل عليه من",

  // User Appointments
  PleaseLoginToView: "يرجى تسجيل الدخول لعرض مواعيدك",
  SignInToAccess: "سجل الدخول للوصول إلى سجل المواعيد وإدارة الحجوزات",
  LoadingYourAppointments: "جاري تحميل مواعيدك...",
  ManageYourBookings: "إدارة حجوزاتك القادمة",
  User: "مستخدم",
  Logout: "تسجيل الخروج",
  NoAppointmentsYet: "لا توجد مواعيد بعد",
  BookYourFirst: "احجز موعدك الأول للبدء في خدماتنا",
  TodaysAppointment: "موعد اليوم",
  Past: "سابق",
  Min: "دقيقة",
  Total: "المجموع",
  CancelAppointment: "إلغاء الموعد",
  CancelAppointmentQuestion: "إلغاء الموعد؟",
  CancelConfirmation:
    "هل أنت متأكد من أنك تريد إلغاء هذا الموعد؟ لا يمكن التراجع عن هذا الإجراء.",
  KeepIt: "الاحتفاظ به",
  YesCancel: "نعم، إلغاء",

  // Login
  Login: "تسجيل الدخول",
  BarberStep: "الحلاق",
  ServicesStep: "الخدمات",
  Welcome: "مرحباً! 👋",
  EnterPhoneToGetStarted: "أدخل رقم هاتفك للبدء",
  PhoneNumber: "رقم الهاتف",
  FullNumber: "الرقم الكامل:",
  Sending: "جاري الإرسال...",
  SendVerificationCode: "إرسال رمز التحقق",
  VerifyYourNumber: "تحقق من رقمك 🔐",
  WeSentCodeTo: "أرسلنا رمزاً إلى",
  VerificationCode: "رمز التحقق",
  EnterSixDigitCode: "أدخل الرمز المكون من 6 أرقام",
  Verifying: "جاري التحقق...",
  VerifyCode: "تحقق من الرمز",
  Verify: "تحقق",
  ChangePhoneNumber: "→ تغيير رقم الهاتف",
  AlmostThere: "تقريباً انتهينا! ✨",
  EnterNameToComplete: "الرجاء إدخال اسمك لإكمال التسجيل",
  YourName: "اسمك",
  Name: "الاسم",
  EnterFullName: "أدخل اسمك الكامل",
  Completing: "جاري الإكمال...",
  CompleteRegistration: "إكمال التسجيل",
  PleaseEnterValidPhone: "الرجاء إدخال رقم هاتف صحيح",
  OTPSentTo: "تم إرسال رمز التحقق إلى",
  ErrorMessage: "خطأ:",
  PhoneVerifiedSuccessfully: "تم التحقق من الهاتف بنجاح!",
  PleaseEnterValidOTP: "الرجاء إدخال رمز صحيح مكون من 6 أرقام",
  InvalidOTP: "رمز غير صحيح. يرجى المحاولة مرة أخرى.",
  PleaseEnterYourName: "الرجاء إدخال اسمك",
  LoginSuccessful: "تم تسجيل الدخول بنجاح!",
  FailedToSaveUser: "فشل حفظ المستخدم:",

  // Booking Confirmation
  ConfirmYourBooking: "أكد حجزك",
  ReviewAppointmentDetails: "راجع تفاصيل موعدك أدناه",
  YourInformation: "معلوماتك",
  Guest: "ضيف",
  NotAvailable: "غير متوفر",
  BarberDetails: "تفاصيل الحلاق",
  AppointmentDetails: "تفاصيل الموعد",
  Date: "التاريخ",
  Time: "الوقت",
  Duration: "المدة",
  SelectedServicesUpper: "الخدمات المحددة",
  Cancel: "إلغاء",
  BookingInProgress: "جاري الحجز...",
  ConfirmBooking: "تأكيد الحجز",
  ConfirmationMessage: "رسالة التأكيد",
  WhatsAppConfirmation: "ستتلقى رسالة تأكيد عبر الواتساب قريباً",
  NoConsecutiveSlotsFound:
    "لم يتم العثور على فترات متتالية بـ {duration} دقيقة متاحة. حاول اختيار تاريخ آخر أو خدمات أقل.",
  PleaseSelectAnotherDate: "يرجى اختيار تاريخ آخر",

  // Main Page Categories
  WhatAreYouLookingFor: "ماذا تبحث عن؟",
  BrowseCategories: "تصفح الفئات",
  Haircut: "قصة شعر",
  Nails: "أظافر",
  Lashes: "رموش",

  // Main Page Login Modal
  SignInToContinue: "سجل الدخول للمتابعة",

  // Review Dialog
  EditName: "تعديل الاسم",
  Save: "حفظ",
  Rating: "التقييم",
  Comment: "تعليق",
  Optional: "اختياري",
  ShareYourThoughts: "شارك آراءك حول الخدمة...",
  ShareYourExperience: "شارك تجربتك مع هذه الخدمة",
  Submit: "إرسال التقييم",
  Poor: "ضعيف",
  Fair: "مقبول",
  Good: "جيد",
  VeryGood: "جيد جداً",
  Excellent: "ممتاز",
  ReviewSubmitted: "تم إرسال التقييم",
  ErrorSubmittingReview: "خطأ في إرسال التقييم. يرجى المحاولة مرة أخرى.",
  PleaseSelectRating: "يرجى اختيار تقييم",
  ErrorUpdatingName: "خطأ في تحديث الاسم",
  ResendCode: "إعادة إرسال الرمز",

  // Cancellation Policy
  CancellationPolicy: "سياسة الإلغاء",
  CancellationPolicyNote: "لا يمكن إلغاء المواعيد في غضون 4 ساعات من الوقت المحدد. يرجى التخطيط وفقاً لذلك.",
};

const he = {
  Featured: "מומלץ",
  MainGalleryImage: "תמונת גלריה ראשית",
  Loadinggallery: "טוען גלריה...",
  NoImagesYet: "אין עדיין תמונות",
  Checkbacksoonforourlatestwork: "בדוק שוב בקרוב לעבודות האחרונות שלנו",
  Galleryimage: "תמונת גלריה",
  View: "צפה",
  Close: "סגור",
  Previousimage: "תמונה קודמת",
  Nextimage: "תמונה הבאה",
  // Days of the week (short)
  Sun: "א׳",
  Mon: "ב׳",
  Tue: "ג׳",
  Wed: "ד׳",
  Thu: "ה׳",
  Fri: "ו׳",
  Sat: "ש׳",
  // Days of the week (full)
  Sunday: "ראשון",
  Monday: "שני",
  Tuesday: "שלישי",
  Wednesday: "רביעי",
  Thursday: "חמישי",
  Friday: "שישי",
  Saturday: "שבת",
  // Months (short)
  Jan: "ינו׳",
  Feb: "פבר׳",
  Mar: "מרץ",
  Apr: "אפר׳",
  May: "מאי",
  Jun: "יוני",
  Jul: "יולי",
  Aug: "אוג׳",
  Sep: "ספט׳",
  Oct: "אוק׳",
  Nov: "נוב׳",
  Dec: "דצמ׳",
  // Months (full)
  January: "ינואר",
  February: "פברואר",
  March: "מרץ",
  April: "אפריל",
  June: "יוני",
  July: "יולי",
  August: "אוגוסט",
  September: "ספטמבר",
  October: "אוקטובר",
  November: "נובמבר",
  December: "דצמבר",
  // Booking Flow
  SelectABarber: "בחר ספר",
  ChoosePreferredBarber: "בחר את הספר המועדף עליך כדי להמשיך",
  NextSelectServices: "הבא: בחר שירותים",
  ChooseYourBarber: "בחר את הספר שלך",
  SelectBarberForAppointment: "בחר ספר לתור שלך",
  Barber: "ספר",
  ProfessionalBarber: "ספר מקצועי",
  Change: "שנה",
  YourBarber: "הספר שלך",
  SelectYourServices: "בחר את השירותים שלך",
  ChooseOneOrMoreServices: "בחר שירות אחד או יותר",
  Minutes: "דקות",
  TotalDuration: "משך זמן כולל",
  TotalPrice: "מחיר כולל",
  SelectAtLeastOneService: "בחר לפחות שירות אחד",
  ChooseFromServices: "בחר מהשירותים הזמינים למעלה",
  NextSelectDateTime: "הבא: בחר תאריך ושעה",
  SelectedServices: "שירותים שנבחרו",
  Edit: "ערוך",
  SelectDate: "בחר תאריך",
  Today: "היום",
  AvailableTimes: "זמנים פנויים",
  TotalDurationNeeded: "משך זמן כולל נדרש:",
  ShowingConsecutiveSlots: "מציג רק משבצות זמן עם זמינות רצופה מספקת",
  NoAvailableAppointments: "אין תורים פנויים",
  BackToServices: "חזרה לשירותים",
  Services: "שירותים",
  Book: "הזמן",

  // Contact
  NeedHelpOrHaveQuestions: "צריכים עזרה או יש שאלות?",
  ContactOurSupportTeam: "צרו קשר עם צוות התמיכה שלנו - אנחנו כאן כדי לעזור",
  ContactOnWhatsApp: "צור קשר בוואטסאפ",
  WhatsApp: "וואטסאפ",
  ChatWithUs: "שוחחו איתנו",
  Phone: "טלפון",
  CallUs: "התקשרו אלינו ישירות",
  Contact: "צור קשר",
  GetInTouch: "צור קשר",
  ContactDescription: "יש לך שאלות? אנחנו כאן לעזור!",
  SMS: "הודעת טקסט",
  TextUs: "שלח לנו הודעה",
  ContactAvailability: "זמינים 24/7 לסייע לך",

  // Navigation
  Features: "תכונות",
  MobileApp: "אפליקציה",
  Benefits: "יתרונות",
  GetStarted: "התחל עכשיו",

  // Hero Section
  TrustedByProfessionals: "🚀 מהימן על ידי למעלה מ-10,000 אנשי מקצוע",
  AppointmentManagement: "ניהול תורים,",
  Simplified: "פשוט",
  HeroDescription:
    "המר את הכאוס בתזמון שלך לפעולות חלקות. נהול תורם מביא יחד כלי הזמנה חזקים, ניהול לקוחות וניתוח בפלטפורמה אחת יפה.",
  StartFreeTrial: "התחל תקופת ניסיון חינמית",
  WatchDemo: "צפה בהדגמה",

  // Stats
  ActiveUsers: "משתמשים פעילים",
  AppointmentsBooked: "תורים שנקבעו",
  Uptime: "זמן פעילות",
  UserRating: "דירוג משתמשים",

  // Features Section
  EverythingYouNeedTo: "כל מה שאתה צריך",
  Succeed: "להצליח",
  BuiltForProfessionals: "נבנה עבור אנשי מקצוע שדורשים מצוינות בכל פרט",

  SmartScheduling: "תזמון חכם",
  SmartSchedulingDesc:
    "ניהול תורים חכם שמתאים לזרימת העבודה שלך ומבטל הזמנות כפולות",
  SmartSchedulingStat: "דיוק של 99.8%",

  ClientManagement: "ניהול לקוחות",
  ClientManagementDesc:
    "פרופילי לקוחות מקיפים עם היסטוריה, העדפות ותקשורת אוטומטית",
  ClientManagementStat: "חיסכון של 50% בזמן",

  AnalyticsInsights: "ניתוחים ותובנות",
  AnalyticsInsightsDesc:
    "סטטיסטיקות בזמן אמת וניתוחים חזוייתיים לשיפור ביצועי העסק שלך",
  AnalyticsInsightsStat: "צמיחה פי 3",

  // Mobile App Section
  AvailableOnMobile: "זמין במובייל",
  ManageEverything: "נהל הכל",
  OnTheGo: "בדרכים",
  MobileAppDescription: "הורד את אפליקציית נהול תורם ושלוט בתורים שלך מכל מקום",

  YourBusinessInYourPocket: "העסק שלך בכיס",
  MobileAppFullDescription:
    "אפליקציית נהול תורם נותנת לך שליטה מלאה על התורים, הלקוחות והניתוחים העסקיים שלך - ישירות מהסמארטפון שלך.",

  RealTimeSync: "סנכרון בזמן אמת",
  RealTimeSyncDesc: "עדכונים מיידיים בכל המכשירים שלך",

  PushNotifications: "התראות דחיפה",
  PushNotificationsDesc: "אל תפספס אף תור או הודעה",

  WorksOffline: "עובד במצב לא מקוון",
  WorksOfflineDesc: "גישה לנתונים שלך גם ללא אינטרנט",

  DownloadNow: "הורד עכשיו",
  GetItOnGooglePlay: "הורד ב",
  GooglePlay: "Google Play",
  DownloadOnTheAppStore: "הורד ב",
  AppStore: "App Store",

  FreeToDownload: "✨ הורדה חינמית • זמין ברחבי העולם • עדכונים קבועים",

  SeeItInAction: "ראה את זה בפעולה",

  // Benefits Section
  WhyProfessionalsChoose: "למה אנשי מקצוע בוחרים ב",
  NeholTorem: "נהול תורם",
  BenefitsDescription:
    "הצטרף לאלפי עסקים ששינו את הפעילות שלהם עם ניהול תורים חכם.",

  SaveHoursDaily: "חסוך שעות מדי יום",
  SaveHoursDesc: "הפוך משימות חוזרות לאוטומטיות והתמקד במה שחשוב",

  NeverMissAppointment: "לעולם אל תפספס תור",
  NeverMissDesc: "תזכורות אוטומטיות והתראות חכמות",

  InstantSetup: "התקנה מיידית",
  InstantSetupDesc: "התחל תוך פחות מ-5 דקות",

  BoostRevenue: "הגדל הכנסות",
  BoostRevenueDesc: "הפחת אי הגעה ב-67% עם תזכורות חכמות",

  TodaysAppointments: "תורים להיום",
  ClientSatisfaction: "שביעות רצון לקוחות",
  ThisMonthRevenue: "הכנסות החודש",
  PercentageFromLastMonth: "+23% מהחודש שעבר",
  ActiveClients: "לקוחות פעילים",
  ShowRate: "אחוז הגעה",

  // CTA Section
  ReadyToTransform: "מוכן לשנות את העסק שלך?",
  CTADescription:
    "הצטרף ליותר מ-10,000 אנשי מקצוע שסומכים על נהול תורם לצרכי התזמון שלהם",
  DownloadApp: "הורד אפליקציה",
  FreeTrial:
    "לא נדרש כרטיס אשראי • תקופת ניסיון חינמית ל-45 יום • ביטול בכל עת",

  // Footer
  Privacy: "פרטיות",
  Terms: "תנאים",
  CopyrightMainPage: "© 2024 נהול תורם. כל הזכויות שמורות.",
  CustomerReviews: "ביקורות לקוחות",
  SeeWhatOurCustomersSay: "ראה מה הלקוחות שלנו אומרים עלינו",
  OutOf: "מתוך",
  Reviews: "ביקורות",
  NoComment: "לא סופק תגובה",
  myappointments: "הפגישות שלי",
  TheMainPage: "עמוד ראשי",
  Gallery: "גלריה",
  ContactInfo: "פרטי קשר",
  Chooselanguage: "בחר שפה",
  Home: "בית",
  MyAppointments: "התורים שלי",
  Loading: "טוען...",
  BookYourAppointment: "קבע תור",
  ChoosePreferredDateTime: "בחר תאריך ושעה מועדפים",
  OnlineBookingComingSoon: "הזמנה מקוונת בקרוב",
  BarberStopDescription:
    "BarberStop מאפשר לתזמן תורים דרך האפליקציה! כרגע, תכונה זו נמצאת בהכנה.",
  InTheMeantime: "בינתיים, קבע את התור שלך דרך:",
  PhoneCall: "שיחת טלפון",
  Tip: "טיפ:",
  MentionBarberStop: 'הזכר את "BarberStop" כשאתה יוצר קשר!',
  ModernBookingSolutions: "פתרונות הזמנה מודרניים",
  Copyright: "© 2026 Bokahit. כל הזכויות שמורות.",

  // Business Owner
  ForBusinessOwners: "לבעלי עסקים",
  WantYourOwnBusinessApp: "רוצה עסק משלך?",
  DownloadNeholToremForBusinessOwners:
    "הורד את נהול תורם והתחל לנהל את מספרת שלך היום!",
  Business: "עסקי",
  WhatsIncluded: "מה כלול:",
  ManageAppointments: "ניהול תורים באינטרנט",
  TrackCustomers: "מעקב אחר הלקוחות שלך",
  IncreaseRevenue: "הגדל את ההכנסות שלך",
  BusinessAnalytics: "ניתוח ודוחות עסקיים",
  JoinThousandsOfBarbers: "הצטרף לאלפי ספרים המנהלים את העסק שלהם עם נהול תורם",
  DownloadOnThe: "הורד ב",
  GetItOn: "הורד ב",

  // User Appointments
  PleaseLoginToView: "אנא התחבר כדי לצפות בתורים שלך",
  SignInToAccess: "התחבר כדי לגשת להיסטוריית התורים ולנהל הזמנות",
  ManageYourBookings: "נהל את ההזמנות הקרובות שלך",
  LoadingYourAppointments: "טוען את התורים שלך...",
  User: "משתמש",
  Logout: "התנתק",
  NoAppointmentsYet: "אין תורים עדיין",
  BookYourFirst: "קבע את התור הראשון שלך כדי להתחיל עם השירותים שלנו",
  TodaysAppointment: "התור של היום",
  Past: "עבר",
  Min: "דקות",
  Total: "סה״כ",
  CancelAppointment: "בטל תור",
  CancelAppointmentQuestion: "לבטל את התור?",
  CancelConfirmation:
    "האם אתה בטוח שברצונך לבטל את התור הזה? לא ניתן לבטל פעולה זו.",
  KeepIt: "שמור אותו",
  YesCancel: "כן, בטל",

  // Login
  Login: "התחבר",
  BarberStep: "ספר",
  ServicesStep: "שירותים",
  Welcome: "ברוך הבא! 👋",
  EnterPhoneToGetStarted: "הזן את מספר הטלפון שלך כדי להתחיל",
  PhoneNumber: "מספר טלפון",
  FullNumber: "מספר מלא:",
  Sending: "שולח...",
  SendVerificationCode: "שלח קוד אימות",
  VerifyYourNumber: "אמת את המספר שלך 🔐",
  WeSentCodeTo: "שלחנו קוד ל",
  VerificationCode: "קוד אימות",
  EnterSixDigitCode: "הזן קוד בן 6 ספרות",
  Verifying: "מאמת...",
  VerifyCode: "אמת קוד",
  Verify: "אמת",
  ChangePhoneNumber: "→ שנה מספר טלפון",
  AlmostThere: "כמעט סיימנו! ✨",
  EnterNameToComplete: "אנא הזן את שמך להשלמת ההרשמה",
  YourName: "השם שלך",
  Name: "שם",
  EnterFullName: "הזן את שמך המלא",
  Completing: "משלים...",
  CompleteRegistration: "השלם הרשמה",
  PleaseEnterValidPhone: "אנא הזן מספר טלפון תקין",
  OTPSentTo: "קוד אימות נשלח ל",
  ErrorMessage: "שגיאה:",
  PhoneVerifiedSuccessfully: "הטלפון אומת בהצלחה!",
  PleaseEnterValidOTP: "אנא הזן קוד תקין בן 6 ספרות",
  InvalidOTP: "קוד לא תקין. נסה שוב.",
  PleaseEnterYourName: "אנא הזן את שמך",
  LoginSuccessful: "התחברות הצליחה!",
  FailedToSaveUser: "שמירת המשתמש נכשלה:",

  // Booking Confirmation
  ConfirmYourBooking: "אשר את ההזמנה שלך",
  ReviewAppointmentDetails: "סקור את פרטי התור שלך למטה",
  YourInformation: "המידע שלך",
  Guest: "אורח",
  NotAvailable: "לא זמין",
  BarberDetails: "פרטי הספר",
  AppointmentDetails: "פרטי התור",
  Date: "תאריך",
  Time: "שעה",
  Duration: "משך",
  SelectedServicesUpper: "שירותים שנבחרו",
  Cancel: "ביטול",
  BookingInProgress: "מזמין...",
  ConfirmBooking: "אשר הזמנה",
  ConfirmationMessage: "הודעת אישור",
  WhatsAppConfirmation: "תקבל הודעת אישור בוואטסאפ בקרוב",
  NoConsecutiveSlotsFound:
    "לא נמצאו משבצות רצופות עם {duration} דקות זמינות. נסה לבחור תאריך אחר או פחות שירותים.",
  PleaseSelectAnotherDate: "אנא בחר תאריך אחר",

  // Main Page Categories
  WhatAreYouLookingFor: "מה אתה מחפש?",
  BrowseCategories: "עיין בקטגוריות",
  Haircut: "תספורת",
  Nails: "ציפורניים",
  Lashes: "ריסים",

  // Main Page Login Modal
  SignInToContinue: "התחבר כדי להמשיך",

  // Review Dialog
  EditName: "ערוך שם",
  Save: "שמור",
  Rating: "דירוג",
  Comment: "תגובה",
  Optional: "אופציונלי",
  ShareYourThoughts: "שתף את מחשבותיך על השירות...",
  ShareYourExperience: "שתף את החוויה שלך עם השירות הזה",
  Submit: "שלח ביקורת",
  Poor: "גרוע",
  Fair: "סביר",
  Good: "טוב",
  VeryGood: "טוב מאוד",
  Excellent: "מצוין",
  ReviewSubmitted: "ביקורת נשלחה",
  ErrorSubmittingReview: "שגיאה בשליחת ביקורת. נסה שוב.",
  PleaseSelectRating: "אנא בחר דירוג",
  ErrorUpdatingName: "שגיאה בעדכון השם",
  ResendCode: "שלח קוד מחדש",

  // Cancellation Policy
  CancellationPolicy: "מדיניות ביטול",
  CancellationPolicyNote: "לא ניתן לבטל תורים בתוך 4 שעות מהמועד הקבוע. אנא תכנן בהתאם.",
};
const sv = {
  // Swedish (sv)
  products: "Produkter",
  description: "Beskrivning",
  itemsAvailable: "produkter tillgängliga",
  youSave: "Du sparar",
  all: "Alla",
  close: "Stäng",
  Morning: "Morgonschema",
  Afternoon: "Eftermiddagsschema",
  Evening: "Kvällsschema",
  WorkingHours: "Öppettider",
  closed: "Stängt",
  LeaveReview: "Lämna recension",
  SalonsFor: "salonger för",
  ShowingMoreThan: "Visar mer än",
  SearchByNameOrPhoneNumber: "Sök på namn eller telefonnummer...",
  Below: "Under",
  AllRatings: "Alla betyg",
  GettingLocation: "Hämtar plats...",
  CloseToMe: "Nära mig",
  BookAppointment: "Boka tid",
  DownloadBokahitBusinessForBusinessOwners:
    "Ladda ner Bokahit Business för företagare",
  ListYourBusiness: "Lista ditt företag",
  FindProfessionalBarbersAndSalons:
    "Hitta professionella frisörer och salonger nära dig. Boka direkt, utan krångel.",
  BookYourAppointmentInSeconds: "Boka din tid på sekunder",
  Featured: "Utvald",
  MainGalleryImage: "Huvudgalleribild",
  Loadinggallery: "Laddar galleri...",
  NoImagesYet: "Inga bilder ännu",
  Checkbacksoonforourlatestwork: "Kom tillbaka snart för vårt senaste arbete",
  Galleryimage: "Galleribild",
  View: "Visa",
  Close: "Stäng",
  Previousimage: "Föregående bild",
  Nextimage: "Nästa bild",
  // Days of the week (short)
  Sun: "Sön",
  Mon: "Mån",
  Tue: "Tis",
  Wed: "Ons",
  Thu: "Tor",
  Fri: "Fre",
  Sat: "Lör",
  // Days of the week (full)
  Sunday: "Söndag",
  Monday: "Måndag",
  Tuesday: "Tisdag",
  Wednesday: "Onsdag",
  Thursday: "Torsdag",
  Friday: "Fredag",
  Saturday: "Lördag",
  // Months (short)
  Jan: "Jan",
  Feb: "Feb",
  Mar: "Mar",
  Apr: "Apr",
  May: "Maj",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Aug",
  Sep: "Sep",
  Oct: "Okt",
  Nov: "Nov",
  Dec: "Dec",
  // Months (full)
  January: "Januari",
  February: "Februari",
  March: "Mars",
  April: "April",
  June: "Juni",
  July: "Juli",
  August: "Augusti",
  September: "September",
  October: "Oktober",
  November: "November",
  December: "December",
  // Booking Flow
  SelectABarber: "Välj en frisör",
  ChoosePreferredBarber: "Välj din föredragna frisör för att fortsätta",
  NextSelectServices: "Nästa: Välj tjänster",
  ChooseYourBarber: "Välj din frisör",
  SelectBarberForAppointment: "Välj en frisör för din bokning",
  Barber: "Frisör",
  ProfessionalBarber: "Professionell frisör",
  Change: "Ändra",
  YourBarber: "Din frisör",
  SelectYourServices: "Välj dina tjänster",
  ChooseOneOrMoreServices: "Välj en eller flera tjänster",
  Minutes: "Minuter",
  TotalDuration: "Total varaktighet",
  TotalPrice: "Totalt pris",
  SelectAtLeastOneService: "Välj minst en tjänst",
  ChooseFromServices: "Välj från de tillgängliga tjänsterna ovan",
  NextSelectDateTime: "Nästa: Välj datum och tid",
  SelectedServices: "Valda tjänster",
  Edit: "Redigera",
  SelectDate: "Välj datum",
  Today: "Idag",
  AvailableTimes: "Tillgängliga tider",
  TotalDurationNeeded: "Total varaktighet som behövs:",
  ShowingConsecutiveSlots:
    "Visar endast tidsluckor med tillräcklig konsekutiv tillgänglighet",
  NoAvailableAppointments: "Inga tillgängliga tider",
  BackToServices: "Tillbaka till tjänster",
  Services: "Tjänster",
  Book: "Boka",

  // Contact
  NeedHelpOrHaveQuestions: "Behöver du hjälp eller har frågor?",
  ContactOurSupportTeam:
    "Kontakta vårt supportteam - vi är här för att hjälpa dig",
  ContactOnWhatsApp: "Kontakta på WhatsApp",
  WhatsApp: "WhatsApp",
  ChatWithUs: "Chatta med oss",
  Phone: "Telefon",
  CallUs: "Ring oss direkt",
  Contact: "Kontakt",
  GetInTouch: "Kontakta oss",
  ContactDescription: "Har du frågor? Vi är här för att hjälpa!",
  SMS: "SMS",
  TextUs: "Skicka oss ett meddelande",
  ContactAvailability: "Tillgängliga 24/7 för att hjälpa dig",

  // Navigation
  Features: "Funktioner",
  MobileApp: "Mobilapp",
  Benefits: "Fördelar",
  GetStarted: "Kom igång",

  // Hero Section
  TrustedByProfessionals: "🚀 Betrodd av 10 000+ proffs",
  AppointmentManagement: "Bokningshantering,",
  Simplified: "Förenklad",
  HeroDescription:
    "Förvandla ditt schemaläggningskaos till sömlösa operationer. NoholTorem samlar kraftfulla bokningsverktyg, kundhantering och analyser på en vacker plattform.",
  StartFreeTrial: "Starta gratis provperiod",
  WatchDemo: "Se demo",

  // Stats
  ActiveUsers: "Aktiva användare",
  AppointmentsBooked: "Bokningar gjorda",
  Uptime: "Drifttid",
  UserRating: "Användarbetyg",

  // Features Section
  EverythingYouNeedTo: "Allt du behöver för att",
  Succeed: "Lyckas",
  BuiltForProfessionals: "Byggd för proffs som kräver excellens i varje detalj",

  SmartScheduling: "Smart schemaläggning",
  SmartSchedulingDesc:
    "Intelligent bokningshantering som anpassar sig till ditt arbetsflöde och eliminerar dubbelbokningar",
  SmartSchedulingStat: "99,8% noggrannhet",

  ClientManagement: "Kundhantering",
  ClientManagementDesc:
    "Omfattande kundprofiler med historik, preferenser och automatiserad kommunikation",
  ClientManagementStat: "50% tidsbesparing",

  AnalyticsInsights: "Analys & insikter",
  AnalyticsInsightsDesc:
    "Realtidsstatistik och prediktiv analys för att optimera din verksamhet",
  AnalyticsInsightsStat: "3x tillväxt",

  // Mobile App Section
  AvailableOnMobile: "Tillgänglig på mobil",
  ManageEverything: "Hantera allt",
  OnTheGo: "På språng",
  MobileAppDescription:
    "Ladda ner NoholTorem mobilapp och ta kontroll över dina bokningar var som helst",

  YourBusinessInYourPocket: "Din verksamhet i fickan",
  MobileAppFullDescription:
    "NoholTorem mobilapp ger dig fullständig kontroll över dina bokningar, kunder och affärsanalyser - direkt från din smartphone.",

  RealTimeSync: "Realtidssynkronisering",
  RealTimeSyncDesc: "Omedelbara uppdateringar på alla dina enheter",

  PushNotifications: "Push-notifikationer",
  PushNotificationsDesc: "Missa aldrig en bokning eller ett meddelande",

  WorksOffline: "Fungerar offline",
  WorksOfflineDesc: "Åtkomst till din data även utan internet",

  DownloadNow: "Ladda ner nu",
  GetItOnGooglePlay: "LADDA NER PÅ",
  GooglePlay: "Google Play",
  DownloadOnTheAppStore: "Ladda ner på",
  AppStore: "App Store",

  FreeToDownload:
    "✨ Gratis att ladda ner • Tillgänglig världen över • Regelbundna uppdateringar",

  SeeItInAction: "Se den i aktion",

  // Benefits Section
  WhyProfessionalsChoose: "Varför proffs väljer",
  NoholTorem: "NoholTorem",
  BenefitsDescription:
    "Gå med tusentals företag som har förvandlat sin verksamhet med intelligent bokningshantering.",

  SaveHoursDaily: "Spara timmar dagligen",
  SaveHoursDesc:
    "Automatisera repetitiva uppgifter och fokusera på det som är viktigt",

  NeverMissAppointment: "Missa aldrig en bokning",
  NeverMissDesc: "Automatiska påminnelser och smarta notifikationer",

  InstantSetup: "Omedelbar installation",
  InstantSetupDesc: "Kom igång på mindre än 5 minuter",

  BoostRevenue: "Öka intäkterna",
  BoostRevenueDesc: "Minska uteblivna besök med 67% med smarta påminnelser",

  TodaysAppointments: "Dagens bokningar",
  ClientSatisfaction: "Kundnöjdhet",
  ThisMonthRevenue: "Denna månads intäkter",
  PercentageFromLastMonth: "+23% från förra månaden",
  ActiveClients: "Aktiva kunder",
  ShowRate: "Uppvisningsgrad",

  // CTA Section
  ReadyToTransform: "Redo att förändra din verksamhet?",
  CTADescription:
    "Gå med 10 000+ proffs som litar på NoholTorem för sina schemaläggningsbehov",
  DownloadApp: "Ladda ner app",
  FreeTrial:
    "Inget kreditkort krävs • 45 dagars gratis provperiod • Avbryt när som helst",

  // Footer
  Privacy: "Integritet",
  Terms: "Villkor",
  CopyrightMainPage: "© 2024 NoholTorem. Alla rättigheter förbehållna.",
  CustomerReviews: "Kundrecensioner",
  SeeWhatOurCustomersSay: "Se vad våra kunder säger om oss",
  OutOf: "av",
  Reviews: "recensioner",
  NoComment: "Ingen kommentar tillhandahållen",
  TheMainPage: "Huvudsida",
  Gallery: "Galleri",
  myappointments: "Mina bokningar",
  ContactInfo: "Kontaktinformation",
  Chooselanguage: "Välj språk",
  Home: "Hem",
  MyAppointments: "Mina bokningar",
  Loading: "Laddar...",
  BookYourAppointment: "Boka din tid",
  ChoosePreferredDateTime: "Välj önskat datum och tid",
  OnlineBookingComingSoon: "Online-bokning kommer snart",
  BarberStopDescription:
    "BarberStop möjliggör schemaläggning av bokningar via appen! För närvarande håller denna funktion på att ställas in.",
  InTheMeantime: "Under tiden, boka din tid via:",
  PhoneCall: "Telefonsamtal",
  Tip: "Tips:",
  MentionBarberStop: 'Nämn "BarberStop" när du hör av dig!',
  ModernBookingSolutions: "Moderna bokningslösningar",
  Copyright: "© 2026 Bokahit. Alla rättigheter förbehållna.",

  // Business Owner
  ForBusinessOwners: "För företagare",
  WantYourOwnBusinessApp: "Vill du ha din egen verksamhet?",
  DownloadNoholToremForBusinessOwners:
    "Ladda ner NoholTorem och börja hantera din frisersalong idag!",
  Business: "Företag",
  WhatsIncluded: "Vad ingår:",
  ManageAppointments: "Hantera bokningar online",
  TrackCustomers: "Spåra dina kunder",
  IncreaseRevenue: "Öka dina intäkter",
  BusinessAnalytics: "Affärsanalyser och rapporter",
  JoinThousandsOfBarbers:
    "Gå med tusentals frisörer som hanterar sin verksamhet med NoholTorem",
  DownloadOnThe: "Ladda ner på",
  GetItOn: "LADDA NER PÅ",

  // User Appointments
  PleaseLoginToView: "Vänligen logga in för att se dina bokningar",
  SignInToAccess:
    "Logga in för att komma åt din bokningshistorik och hantera bokningar",
  LoadingYourAppointments: "Laddar dina bokningar...",
  ManageYourBookings: "Hantera dina kommande bokningar",
  User: "Användare",
  Logout: "Logga ut",
  NoAppointmentsYet: "Inga bokningar än",
  BookYourFirst: "Boka din första tid för att komma igång med våra tjänster",
  TodaysAppointment: "Dagens bokning",
  Past: "Tidigare",
  Min: "min",
  Total: "Totalt",
  CancelAppointment: "Avboka tid",
  CancelAppointmentQuestion: "Avboka tid?",
  CancelConfirmation:
    "Är du säker på att du vill avboka denna tid? Detta kan inte ångras.",
  KeepIt: "Behåll den",
  YesCancel: "Ja, avboka",

  // Login
  Login: "Logga in",
  BarberStep: "Frisör",
  ServicesStep: "Tjänster",
  Welcome: "Välkommen! 👋",
  EnterPhoneToGetStarted: "Ange ditt telefonnummer för att komma igång",
  PhoneNumber: "Telefonnummer",
  FullNumber: "Fullständigt nummer:",
  Sending: "Skickar...",
  SendVerificationCode: "Skicka verifieringskod",
  VerifyYourNumber: "Verifiera ditt nummer 🔐",
  WeSentCodeTo: "Vi skickade en kod till",
  VerificationCode: "Verifieringskod",
  EnterSixDigitCode: "Ange 6-siffrig kod",
  Verifying: "Verifierar...",
  VerifyCode: "Verifiera kod",
  Verify: "Verifiera",
  ChangePhoneNumber: "← Ändra telefonnummer",
  AlmostThere: "Nästan klar! ✨",
  EnterNameToComplete:
    "Vänligen ange ditt namn för att slutföra registreringen",
  YourName: "Ditt namn",
  Name: "Namn",
  EnterFullName: "Ange ditt fullständiga namn",
  Completing: "Slutför...",
  CompleteRegistration: "Slutför registrering",
  PleaseEnterValidPhone: "Vänligen ange ett giltigt telefonnummer",
  OTPSentTo: "Engångskod skickad till",
  ErrorMessage: "Fel:",
  PhoneVerifiedSuccessfully: "Telefon verifierad framgångsrikt!",
  PleaseEnterValidOTP: "Vänligen ange en giltig 6-siffrig kod",
  InvalidOTP: "Ogiltig kod. Vänligen försök igen.",
  PleaseEnterYourName: "Vänligen ange ditt namn",
  LoginSuccessful: "Inloggning lyckades!",
  FailedToSaveUser: "Misslyckades med att spara användare:",

  // Booking Confirmation
  ConfirmYourBooking: "Bekräfta din bokning",
  ReviewAppointmentDetails: "Granska dina bokningsdetaljer nedan",
  YourInformation: "DIN INFORMATION",
  Guest: "Gäst",
  NotAvailable: "Ej tillgänglig",
  BarberDetails: "FRISÖRDETALJER",
  AppointmentDetails: "BOKNINGSDETALJER",
  Date: "Datum",
  Time: "Tid",
  Duration: "Varaktighet",
  SelectedServicesUpper: "VALDA TJÄNSTER",
  Cancel: "Avbryt",
  BookingInProgress: "Bokar...",
  ConfirmBooking: "Bekräfta bokning",
  ConfirmationMessage: "Bekräftelsemeddelande",
  WhatsAppConfirmation: "Du kommer att få en WhatsApp-bekräftelse inom kort",
  NoConsecutiveSlotsFound:
    "Inga konsekutiva tidsplatser hittades med {duration} minuter tillgängliga. Försök välja ett annat datum eller färre tjänster.",
  PleaseSelectAnotherDate: "Vänligen välj ett annat datum",

  // Main Page Categories
  WhatAreYouLookingFor: "Vad letar du efter?",
  BrowseCategories: "Bläddra i kategorier",
  Haircut: "Klippning",
  Nails: "Naglar",
  Lashes: "Fransar",

  // Main Page Login Modal
  SignInToContinue: "Logga in för att fortsätta",

  // Review Dialog
  EditName: "Redigera namn",
  Save: "Spara",
  Rating: "Betyg",
  Comment: "Kommentar",
  Optional: "Valfritt",
  ShareYourThoughts: "Dela dina tankar om tjänsten...",
  ShareYourExperience: "Dela din upplevelse av denna tjänst",
  Submit: "Skicka recension",
  Poor: "Dålig",
  Fair: "Okej",
  Good: "Bra",
  VeryGood: "Mycket bra",
  Excellent: "Utmärkt",
  ReviewSubmitted: "Recension skickad",
  ErrorSubmittingReview: "Fel vid skickande av recension. Försök igen.",
  PleaseSelectRating: "Välj ett betyg",
  ErrorUpdatingName: "Fel vid uppdatering av namn",
  ResendCode: "Skicka koden igen",

  // Cancellation Policy
  CancellationPolicy: "Avbokningspolicy",
  CancellationPolicyNote: "Bokningar kan inte avbokas inom 4 timmar från den inbokade tiden. Vänligen planera i förväg.",
};
const resources = {
  en: {
    translation: en,
  },
  ar: {
    translation: ar,
  },
  he: {
    translation: he,
  },
  sv: {
    translation: sv,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "sv", // default language
  fallbackLng: "sv",
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
